module.exports = __webpack_public_path__ + "assets/retina_HypotenuseAndAltitudeDetailed.3d5256f736b54351b847cd77a1e56b24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_HypotenuseAndAltitudeDetailed.png
// module id = 676
// module chunks = 0